import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useBrandAccountSurveysQueryKey } from './useBrandAccountSurveysQueryKey'

export const useInvalidateBrandAccountSurveysQuery = (
  brandAccountId: string | undefined,
) => {
  const queryClient = useQueryClient()
  const queryKey = useBrandAccountSurveysQueryKey(brandAccountId)

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
